"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var SvgError = function SvgError(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "currentColor",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#FFF",
    opacity: 0.88,
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 3.871c14.35 0 26.129 11.622 26.129 26.129 0 14.43-11.687 26.129-26.129 26.129-14.425 0-26.129-11.68-26.129-26.129C3.871 15.58 15.557 3.871 30 3.871M30 0C13.433 0 0 13.437 0 30c0 16.572 13.433 30 30 30s30-13.428 30-30C60 13.437 46.567 0 30 0zm-1.39 14.516h2.78c.825 0 1.485.687 1.45 1.512l-.847 20.323a1.452 1.452 0 01-1.45 1.39h-1.086a1.452 1.452 0 01-1.45-1.39l-.847-20.323a1.452 1.452 0 011.45-1.512zM30 40.161a3.387 3.387 0 100 6.774 3.387 3.387 0 000-6.774z",
    fill: "currentColor"
  })));
};
var _default = exports.default = SvgError;